import React from 'react'
import { observer } from 'mobx-react'
import { Tabs, Tab, DropdownButton, MenuItem } from 'react-bootstrap'
import I18nInput from '../../input/filmAttrI18n'
import * as defaultConst from '../../../constants/default_constants'

@observer
export default class LanguageTabs extends React.Component {
  render () {
    const { store, disabled, updateField, errors, autoName, assetRefs, assetRefsKey } = this.props
    const entity = store.cv.record
    const listOfLanguages = store.options.has('FilmCargoLanguages') && store.options.get('FilmCargoLanguages')

    const AddLanguageDropDown = observer(({ store }) => {
      const title = (<span>
        <i className='glyphicon glyphicon-plus-sign' />&nbsp;
        {store.activeLanguages.length <= 4 ? store.__('Add language') : store.__('Add')}
      </span>)
      const confirmRemove = store.__('Really remove this language?')

      return !disabled && listOfLanguages && listOfLanguages.length > 0 &&
        <div className='languages-dropdown'>
          <DropdownButton bsStyle='primary' bsSize='small' title={title}>
            {listOfLanguages.map(i => {
              const lang = i.value
              const isEN = lang === defaultConst.DEFAULT_LANG
              const isActive = store.activeLanguages.includes(lang) || isEN

              return (
                <MenuItem key={lang} eventKey={lang} tabClassName={isActive && 'text-info'} disabled={isEN}
                  onClick={isEN
                    ? undefined
                    : () => isActive
                      ? confirm(confirmRemove) && store.updateAttrsLanguage(store, lang, true)
                      : store.updateAttrsLanguage(store, lang)
                  }>
                  {isEN
                    ? <span><span className='glyphicon glyphicon-ban-circle' /></span>
                    : (isActive
                      ? <span className='text-danger'><span className='glyphicon glyphicon-remove' /></span>
                      : <span className='text-success'><span className='glyphicon glyphicon-plus-sign' /></span>)
                  } &nbsp;
                  {i.text}
                  {isEN && <em>&nbsp;({store.__('default')})</em>}
                </MenuItem>
              )
            })
            }
          </DropdownButton>
        </div>
    })

    return <React.Fragment>
      <AddLanguageDropDown store={store}/>

      <Tabs activeKey={store.activeLanguages.includes(store.languageFilter)
        ? store.languageFilter
        : defaultConst.DEFAULT_LANG}
      onSelect={store.setActiveLanguage.bind(store)}>

        {store.activeLanguages.map(lang => {
          const langTitle = listOfLanguages && listOfLanguages.find(i => i.value === lang)
          const langTitleText = (langTitle && langTitle.text.concat(' ')) || (lang && lang.toUpperCase())
          const isAutoName = autoName && lang === defaultConst.DEFAULT_LANG

          return (
            <Tab key={lang} eventKey={lang} title={<strong> {lang && lang.toUpperCase()} </strong>}>
              <I18nInput
                attr={lang === defaultConst.DEFAULT_LANG && 'common.name'} // necessary because validation
                attrs={entity.get('attrs')}
                disabled={disabled || isAutoName}
                errors={errors}
                label={langTitleText + store.__(' distribution title')}
                language={lang}
                name='name'
                assetRefs={assetRefs}
                assetRefsKey={assetRefsKey + '-name-' + lang}
                onChange={updateField}
                optionsMap={store.options}
                platform='common'
                store={store}
              />
              <I18nInput
                attrs={entity.get('attrs')}
                disabled={disabled}
                errors={errors}
                label={langTitleText + store.__(' long synopsis')}
                language={lang}
                name='desc'
                assetRefs={assetRefs}
                assetRefsKey={assetRefsKey + '-desc-' + lang}
                onChange={updateField}
                optionsMap={store.options}
                platform='common'
                rows={5}
                store={store}
                InputComponent='textarea' />
              <I18nInput
                attrs={entity.get('attrs')}
                disabled={disabled}
                errors={errors}
                label={langTitleText + store.__(' short synopsis')}
                language={lang}
                name='shortdesc'
                assetRefs={assetRefs}
                assetRefsKey={assetRefsKey + '-shortdesc-' + lang}
                onChange={updateField}
                optionsMap={store.options}
                platform='common'
                rows={2}
                store={store}
                InputComponent='textarea' />
            </Tab>
          )
        })}
      </Tabs>
      <hr />
    </React.Fragment>
  }
}
